import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Link } from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import moment from 'moment';
import { IssueAttach } from '../data/IssueAttach';
import { useRootStore } from '../hooks/useRootStore';
import { useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

export default function IssueAttachListDialog({ issueId, attaches, onClose }: { issueId: number, attaches: IssueAttach[], onClose: (changed: IssueAttach[]) => void }) {

    const { api, userProfile } = useRootStore();
    const [changed, setChanged] = useState(attaches);

    function uploadFile(file: File) {
        const reader = new FileReader();
        reader.onload = () => {
            api.uploadIssueAttach(issueId, file, file.name).then(url => {
                const id = parseInt(url.match(/ID=([0-9]+)/)![1]);
                const hash = url.match(/hash=(.+)/)![1];
                setChanged([...changed, {
                    AuthorID: userProfile!.ID,
                    AuthorName: `${userProfile!.LastName} ${userProfile!.FirstName}`,
                    FileName: file.name,
                    Hash: hash,
                    ID: id,
                    UploadDate: new Date(),
                } as IssueAttach])
            });
            //setChanged({ ...changed, Avatar: reader.result as string })
        };
        reader.readAsDataURL(file);
    }

    const columns: GridColDef[] = [
        { field: 'ID', headerName: 'ID' },
        { field: 'FileName', headerName: 'Файл', width: 180, renderCell: (params) => <Link href={`json/reply/GetIssueAttach?ID=${params.row.ID}&hash=${params.row.Hash}`}>{params.value}</Link> },
        { field: 'UploadDate', headerName: 'Загружено', align: 'center', width: 150, valueFormatter: (value?: Date) => value ? moment(value).format("DD.MM.YY HH:mm") : null },
        { field: 'AuthorID', headerName: 'Загрузил', width: 180, renderCell: (params) => <Link href={`/employees/${params.value}`}>{params.row.AuthorName}</Link> },
    ];
    return (
        <Box>
            <Dialog
                open={true}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle>Приложения к задаче</DialogTitle>
                <HighlightOffOutlinedIcon sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} onClick={() => onClose(changed)} />
                <DialogContent>
                    <DataGrid
                        rows={changed}
                        getRowHeight={() => 'auto'}
                        getRowId={(row) => row.ID}
                        columns={columns}
                        //initialState={{ pagination: { paginationModel } }}
                        //pageSizeOptions={[5, 10]}
                        // checkboxSelection
                        sx={{ border: 0 }}
                    />
                    <Box>
                        <label htmlFor="upload-file" style={{ cursor: 'pointer', color: '#1976d2', display: 'inline-block', padding:'5px 10px'}}>
                            <>
                                Добавить файл
                                <input
                                    type="file"
                                    id="upload-file"
                                    hidden
                                    onChange={(e) => {
                                        if (e.target?.files?.length ?? 0 > 0) {
                                            uploadFile(e.target.files![0]);
                                        }
                                    }}
                                />
                            </>
                        </label>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    );
}